module.exports = "<div> <h2 data-translate=\"LEISTUNGSEMPFAENGER\"></h2> <div class=\"row\"> <div class=\"col-sm-3 dv-input-container-medium\"> <dv-input-container> <label data-translate=\"KONTO_INHABER\"> </label> <div class=\"noselect\" ng-bind=\"vm.inhaberName\"></div> </dv-input-container> </div> <div class=\"col-sm-3 dv-input-container-medium\"> <dv-input-container> <label data-translate=\"IBAN\"> </label> <div class=\"noselect\" ng-bind=\"vm.iban\"></div> </dv-input-container> </div> </div> </div> ";


//////////////////
// WEBPACK FOOTER
// ./src/app/core/component/dv-leistungsempfaenger/dv-leistungsempfaenger.html
// module id = 1Zuw
// module chunks = 0